import React from 'react'
import PropTypes from 'prop-types'
import NRTFormInput from "../../../../../_common/_form/FormInput"

import './style.css'
import {Validators} from "../../../../../_common/_form/Validators"

const NRTQuestionTrueOrFalse = (props) => {

    return (
        <div className={'nrt-ead-question-truefalse'}>
            {
                props.optionDTOs.sort((a,b) => a.order - b.order).map((option) => {

                    const filteredAnswer = props.answer ? props.answer.filter(a => a.id === option.code) : []

                    return (
                        <div
                            key={props.code +'.' + option.code }
                            style={{
                            marginBottom: '1rem'
                        }}>

                            <p>{option.text}</p>

                            <NRTFormInput
                                name={props.code +'.' + option.code}
                                type={'radiogroup'}
                                value={filteredAnswer.length > 0 ? filteredAnswer.filter(a => a.id === option.code)[0].value === 'true' : null}
                                disabled={props.disabled}
                                validators={[
                                    Validators.required()
                                ]}
                                customProps={{
                                    style: {
                                        display: 'flex'
                                    },
                                    options: [
                                        {
                                            display: 'Verdadeiro',
                                            value: true,
                                        },
                                        {
                                            display: 'Falso',
                                            value: false,
                                        }
                                    ]
                                }}
                            />
                        </div>
                    )
                })
            }
        </div>
    )
}

NRTQuestionTrueOrFalse.propTypes = {
    id: PropTypes.string.isRequired  ,
    statements: PropTypes.arrayOf(PropTypes.string)
}

NRTQuestionTrueOrFalse.defaultProps = {}

export default NRTQuestionTrueOrFalse



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/Questions/_components/TrueOfFalse/index.js